import React from 'react';

const SpinnerContext = React.createContext();

export default SpinnerContext;
